// @flow

import { freeze } from "icepick";
import {
    FETCH_USER_INFO_SUCCESS,
    FETCH_USER_INFO_ERROR,
    FETCH_SESSION_INFO_SUCCESS,
    FETCH_SESSION_INFO_ERROR,
    DISMISS_ERROR_FLAG,
    DISMISS_SUCCESS_FLAG,
    SHOW_DIALOG,
    HIDE_DIALOG
} from "./actions";

import type { ContextState } from "./types";

const initialState: ContextState = freeze({
    cloudId: "",
    userInfo: null,
    sessionInfo: null,
    hasErrors: false,
    showSuccessFlag: false,
    dialogs: {}
});

export const isDialogOpen = (state, name) =>
    state.context.dialogs && state.context.dialogs[name] && state.context.dialogs[name].open;

export default (state = initialState, action) => {
    const { type, payload } = action;
    const stateDialogs = JSON.parse(JSON.stringify(state.dialogs));

    switch (type) {
        case FETCH_USER_INFO_SUCCESS:
            return freeze({
                ...state,
                userInfo: payload
            });
        case FETCH_SESSION_INFO_SUCCESS:
            return freeze({
                ...state,
                sessionInfo: payload
            });
        case FETCH_USER_INFO_ERROR:
            return freeze({
                ...state,
                userInfo: []
            });
        case DISMISS_ERROR_FLAG:
            return freeze({
                ...state,
                hasErrors: false
            });
        case DISMISS_SUCCESS_FLAG:
            return freeze({
                ...state,
                showSuccessFlag: false
            });
        case SHOW_DIALOG:
            if (!stateDialogs[payload]) {
                stateDialogs[payload] = {};
            }
            stateDialogs[payload].open = true;
            return freeze({
                ...state,
                dialogs: stateDialogs
            });
        case HIDE_DIALOG:
            if (!stateDialogs[payload]) {
                stateDialogs[payload] = {};
            }
            stateDialogs[payload].open = false;
            return freeze({
                ...state,
                dialogs: stateDialogs
            });
        case FETCH_SESSION_INFO_ERROR:
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/state/context/reducer.js